import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormControl } from '@angular/forms';
import { MatDialog, MatPaginator, MatTableDataSource } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { IMessage } from 'src/app/models/IMedicationHistoryDTO';
import { IMessagingSender, MessageInbox } from 'src/app/models/IMessaging';
import { PatientBannerService } from 'src/app/patient-banner/patient-banner.service';
import { MessagesService } from 'src/app/Services/Messages/messages.service';
import { RxService } from 'src/app/Services/NewVisitNote/rx.service';
import { TasksAndGroupsService } from 'src/app/Services/TaskAndGroup/tasks-and-groups.service';
import { SharedService } from 'src/app/Sharedservice/SharedService';
import { configuration } from 'src/environments/environment';
import { PatientSecureMessagesComponent } from '../patient-secure-messages/patient-secure-messages.component';
import { CommonComponents } from 'src/app/Sharedservice/CommonComponents';

@Component({
  selector: 'app-message-inbox',
  templateUrl: './message-inbox.component.html',
  styleUrls: ['./message-inbox.component.css']
})
export class MessageInboxComponent implements OnInit {

  displayedColumns1 = ['patientName', 'requestTime', 'requestType', 'status', 'Action'];
  displayedColumnsSecureMessages = ['patientNameDOB', 'requestTime', 'requestType', 'fromUser', 'Action'];
  Messagesdata: any[] = [];
  secureMessagesData: any[] = [];
  dataSource1 = new MatTableDataSource(this.Messagesdata);
  dataSourceSecureMessages = new MatTableDataSource(this.secureMessagesData);
  allRequestCount: number = 0;
  pendingRequestCount: number = 0;
  messages: MessageInbox[] = [];
  sewcureMessagelist: MessageInbox[] = [];
  public pendingStatusList: MessageInbox[] = [];
  public allStatusList: MessageInbox[] = [];
  isAllBtncolor: boolean = false;
  ispedningBtncolor: boolean = false;
  isSentBtncolor: boolean = false;
  openStatusbuttonColor: boolean = false;
  ISONCEnabled = configuration.ISONCEnabled;

  datatodisplay: string = 'Pending';
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @Output() patientBanner: EventEmitter<any> = new EventEmitter<any>();
  filterValues = { patientName: '', requestTime: '', requestType: '', status: '' };
  patientNameFilter = new FormControl('');
  requestTimeFilter = new FormControl('');
  requestTypeFilter = new FormControl('');
  statusFilter = new FormControl('');
  actionFilter = new FormControl('');
  displayPortalMessages: boolean = true;
  displaySecureMessages: boolean = false;
  constructor(private formBuilder: FormBuilder, private toastr: ToastrService, private messageService: MessagesService, private router: Router, private route: ActivatedRoute, private rxService: RxService, private sharedService: SharedService, public dialog: MatDialog, private bannerService: PatientBannerService
    , private _taskandgroupservice: TasksAndGroupsService,) {
    this.bannerService.toggle(Number("0"));
  }

  ngOnInit() {
    this.loadAllRequests();
    this.getAllSecureMessages();
    this.patientNameFilter.valueChanges
      .subscribe(
        patientName => {
          this.filterValues.patientName = patientName;
          this.dataSource1.filter = JSON.stringify(this.filterValues);
        }
      )

    this.requestTimeFilter.valueChanges
      .subscribe(
        requestTime => {
          this.filterValues.requestTime = requestTime;
          this.dataSource1.filter = JSON.stringify(this.filterValues);
        }
      )

    this.requestTypeFilter.valueChanges
      .subscribe(
        requestType => {
          this.filterValues.requestType = requestType;
          this.dataSource1.filter = JSON.stringify(this.filterValues);
        }
      )

    this.statusFilter.valueChanges
      .subscribe(
        status => {
          this.filterValues.status = status;
          this.dataSource1.filter = JSON.stringify(this.filterValues);
        }
      )
  }

  loadAllRequests() {
    this.messageService.getAllMessagesRequestByPatientPortal(sessionStorage.getItem("userId")).subscribe((data: MessageInbox[]) => {
      this.messages = data;
      this.dataSource1.data = this.messages;
      this.allStatusList = this.messages;
      this.pendingStatusList = this.dataSource1.data.filter(x => x.status === 'Pending')
      // this.allStatusList = this.dataSource1.data.filter(x => x.status != 'Pending')
      this.pendingRequestCount = this.pendingStatusList.length;
      this.allRequestCount = this.allStatusList.length;

      if (this.datatodisplay == 'All') {
        this.isAllBtncolor = true;

        this.ispedningBtncolor = false;
        this.isSentBtncolor = false;
        this.dataSource1.data = this.allStatusList;
      }
      else if (this.datatodisplay == 'Pending') {
        this.isAllBtncolor = false;
        this.ispedningBtncolor = true;
        this.isSentBtncolor = false;
        this.dataSource1.data = this.pendingStatusList;
      } else if (this.datatodisplay == 'Sent') {
        this.isAllBtncolor = false;
        this.ispedningBtncolor = false;
        this.isSentBtncolor = true;
      }
      this.dataSource1.filterPredicate = this.createFilter();
      this.dataSource1.paginator = this.paginator;
    },
      (err: any) => console.log(err)
    );
  }
  getAllSecureMessages() {
    this._taskandgroupservice.getAllSecureMessages(0, 'PortalRequest').subscribe((data: MessageInbox[]) => {
      this.sewcureMessagelist = data;
      this.dataSourceSecureMessages.data = this.sewcureMessagelist;
    },
      (err: any) => console.log(err)
    );
  }
  createFilter(): (data: any, filter: string) => boolean {
    let filterFunction = function (data, filter): boolean {
      let searchTerms = JSON.parse(filter);
      return (data.patientName === null ? "" : data.patientName).toString().toLowerCase().indexOf(searchTerms.patientName) !== -1
        && (data.requestTime === null ? "" : data.requestTime).toString().toLowerCase().indexOf(searchTerms.requestTime) !== -1
        && (data.requestType === null ? "" : data.requestType).toString().toLowerCase().indexOf(searchTerms.requestType) !== -1
        && (data.status === null ? "" : data.status).toString().toLowerCase().indexOf(searchTerms.status) !== -1
        ;
    }
    return filterFunction;
  }
  secureMessageslist: MessageInbox[] = [];
  displayDemographicsInfo(messageInboxObj: MessageInbox) {
    CommonComponents.patientName = messageInboxObj.patientName;
    if (messageInboxObj.requestTypeId == 1) {
      this.router.navigate(['patientRequestInformation', messageInboxObj.linkId, '3']);
    } else if (messageInboxObj.requestTypeId == 2) {
      this.router.navigate(['PPBookAppointment', messageInboxObj.linkId]);
    }
    else if (messageInboxObj.requestTypeId == 3) {
      this.bannerService.toggle(Number("-1"));
      this.router.navigate(['PPDemographics', messageInboxObj.linkId],);
    } else if (messageInboxObj.requestTypeId == 5 || messageInboxObj.requestTypeId == 6) {
      this.bannerService.toggle(Number("-1"));
      this.router.navigate(['InsuranceRequest', messageInboxObj.linkId, messageInboxObj.InsurancedetailsId, messageInboxObj.requestTypeId]);
    }
    else if (messageInboxObj.requestTypeId == 7 || messageInboxObj.requestTypeId == 8) {
      this.bannerService.toggle(Number("-1"));
      this.router.navigate(['EmergencyRequest', messageInboxObj.linkId, messageInboxObj.InsurancedetailsId, messageInboxObj.requestTypeId]);
    }
    else if (messageInboxObj.requestTypeId == 9) {
      this.bannerService.toggle(Number("-1"));
      this.router.navigate(['PPAmmendmentNote', messageInboxObj.requestId],);
    } else if (messageInboxObj.requestType == 'Secure Message') {
      this._taskandgroupservice.getAllSecureMessages(0, 'PortalRequest').subscribe((data: MessageInbox[]) => {
        this.sewcureMessagelist = data;
        this.dataSourceSecureMessages.data = this.sewcureMessagelist;
      },
        (err: any) => console.log(err)
      );

      this._taskandgroupservice.getAllSecureMessages(messageInboxObj.requestId, '').subscribe((data: MessageInbox[]) => {
        this.secureMessageslist = data;
        if (this.secureMessageslist.length > 0) {
          this.secureMessageslist[0].patientName = this.secureMessageslist[0].patientName;
          this.secureMessageslist[0].notes = this.secureMessageslist[0].notes;
          this.secureMessageslist[0].subject = this.secureMessageslist[0].subject;
          this.secureMessageslist[0].fromUser = sessionStorage.getItem("username");
          this.displaySecureMessagesInfo(this.secureMessageslist[0])
        }
      },
        (err: any) => console.log(err)
      );
    }


  }
  click_sentMessages() {
    this.displaySecureMessages = true;
    this.displayPortalMessages = false;
  }
  changeRequestStatus(statusType) {
    this.displayPortalMessages = true;
    this.displaySecureMessages = false;
    if (statusType == 'All') {
      this.isAllBtncolor = true;
      this.ispedningBtncolor = false;
      this.isSentBtncolor = false;

      this.dataSource1.data = this.allStatusList;

    }
    else if (statusType == 'Pending') {
      this.isAllBtncolor = false;
      this.ispedningBtncolor = true;
      this.isSentBtncolor = false;
      this.dataSource1.data = this.pendingStatusList;
    }
    else if (statusType == 'Sent') {
      this.isAllBtncolor = false;
      this.ispedningBtncolor = false;
      this.isSentBtncolor = true;
      this.displaySecureMessages = true;
      this.displaySecureMessages = true;
      this.displayPortalMessages = false;
    }
  }
  funCreateNewSecureMessage() {
    //  alert('Create new Message for Patient')
    const dialogRef = this.dialog.open(PatientSecureMessagesComponent,
      {
        width: '700px ',
        height: '260px',
        data: { Type: 'Create' }
      }
    );
    dialogRef.afterClosed().subscribe(result => {
      if (result && result != undefined) {
        this.getAllSecureMessages();
      }
    });
  }
  displaySecureMessagesInfo(messageInboxObj: MessageInbox) {

    const dialogRef = this.dialog.open(PatientSecureMessagesComponent,
      {
        width: '700px ',
        height: '260px',
        data: { Type: 'SentBox', ele: messageInboxObj }

      }
    );
    dialogRef.afterClosed().subscribe(result => {
      if (result && result != undefined) {
      }
    });
  }
}
